import { useState, useCallback, createContext } from "react";
import { apiBaseurl } from "../utils/ApiBaseurl";

export const WidgetContext = createContext();

export const WidgetProvider = ({ children }) => {
  const [esopWidget, setEsopWidget] = useState(null);
  const [welcomeWidget, setWelcomeWidget] = useState(null);
  const [directDepositWidget, setDirectDepositWidget] = useState(null);
  const [taxPaymentsWidget, setTaxPaymentsWidget] = useState(null);
  const getEsopWidget = useCallback(async () => {
    try {
      const response = await fetch(
        `${apiBaseurl}backend/api/widgets/esop-plan-design`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${
              JSON.parse(localStorage.getItem("authTokens")).access
            }`,
            "Content-Type": "application/json",
          },
        }
      );

      const _widget = await response.json();
      setEsopWidget(_widget);
    } catch (error) {
      console.error("Failed to fetch widget data:", error);
    }
  }, []);

  const getWelcomeWidget = useCallback(async () => {
    try {
      const response = await fetch(
        `${apiBaseurl}backend/api/widgets/welcome-banner`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${
              JSON.parse(localStorage.getItem("authTokens")).access
            }`,
            "Content-Type": "application/json",
          },
        }
      );
      const _widget = await response.json();
      setWelcomeWidget(_widget);
    } catch (error) {
      console.error("Failed to fetch widget data:", error);
    }
  }, []);

  const getDirectDepositWidget = useCallback(async () => {
    try {
      const response = await fetch(
        `${apiBaseurl}backend/api/widgets/banking-info`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${
              JSON.parse(localStorage.getItem("authTokens")).access
            }`,
            "Content-Type": "application/json",
          },
        }
      );
      const _widget = await response.json();
      setDirectDepositWidget(_widget);
    } catch (error) {
      console.error("Failed to fetch widget data:", error);
    }
  }, []);

  const getTaxPaymentsWidget = useCallback(async () => {
    try {
      const response = await fetch(
        `${apiBaseurl}backend/api/widgets/tax-payments-and-tax-filings`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${
              JSON.parse(localStorage.getItem("authTokens")).access
            }`,
            "Content-Type": "application/json",
          },
        }
      );
      const _widget = await response.json();
      setTaxPaymentsWidget(_widget);
    } catch (error) {
      console.error("Failed to fetch widget data:", error);
    }
  }, []);
  return (
    <WidgetContext.Provider
      value={{
        esopWidget,
        welcomeWidget,
        directDepositWidget,
        taxPaymentsWidget,
        getEsopWidget,
        getWelcomeWidget,
        getDirectDepositWidget,
        getTaxPaymentsWidget,
      }}
    >
      {children}
    </WidgetContext.Provider>
  );
};
